export default "__VITE_ASSET__suTK$bzF__"